module.exports = __webpack_public_path__ + "static/media/PearShaped_Diamonds.ec24adbd.jpg";